import { useEffect } from "react";

// Fades elements with the "reveal" class up into view as they scroll in (styles in fashion.css). Runs again when
// `deps` change so newly loaded rows animate too. Shoppers who ask for reduced motion see everything at once.
export default function useReveal(deps = []) {
    useEffect(() => {
        const items = [...document.querySelectorAll(".reveal:not(.isShown)")];
        if (!items.length) return undefined;
        if (!("IntersectionObserver" in window) || window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
            items.forEach((el) => el.classList.add("isShown"));
            return undefined;
        }
        const observer = new IntersectionObserver(
            (entries) => entries.forEach((entry) => {
                if (!entry.isIntersecting) return;
                entry.target.classList.add("isShown");
                observer.unobserve(entry.target);
            }),
            { rootMargin: "0px 0px -8% 0px", threshold: 0.08 }
        );
        items.forEach((el) => observer.observe(el));
        return () => observer.disconnect();
    }, deps);
}
